"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var types = require('./types');

var util = require('./util');

var create = function create(type) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (types[type]) return new types[type](value);
  var temp = type.split('');
  var boundary = [temp[0], temp[temp.length - 1]].join('');
  if (boundary === '[]') return new types.array(type, value);
  if (boundary === '()') return new types.tuple(type, value);
  throw new Error('Invalid type');
};

var span = function span(register) {
  var type = register.type,
      schema = register.schema;
  if (type) return create(type).space;
  return schema.reduce(function (total, nestedRegister) {
    return span(nestedRegister) + total;
  }, 0);
};

var struct = function struct(_schema) {
  var _this = this;

  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, struct);

  _defineProperty(this, "toBuffer", function () {
    var eleBufs = _this.schema.map(function (each) {
      var key = each.key,
          type = each.type,
          schema = each.schema;
      return type ? create(type, _this.value[key]) : new struct(schema, _this.value[key]);
    });

    return util.pack.apply(util, _toConsumableArray(eleBufs));
  });

  _defineProperty(this, "fromBuffer", function (buf) {
    if (!Buffer.isBuffer(buf)) throw new Error('Invalid buffer');
    _this.value = {};
    var offset = 0;

    _this.schema.forEach(function (each) {
      var key = each.key,
          type = each.type,
          schema = each.schema;
      var item = type ? create(type) : new struct(schema);
      var subBuf = buf.slice(offset, offset + item.space);
      item.fromBuffer(subBuf);
      _this.value[key] = item.value;
      offset += item.space;
    });

    return _this.value;
  });

  this.schema = _schema;
  this.value = value;
  this.space = span({
    schema: this.schema
  });
};

module.exports = _objectSpread(_objectSpread(_objectSpread({
  struct: struct
}, types), util), {}, {
  create: create,
  span: span
});